import { UI_STATES } from '../../constants/commonConstants';
import {
	GET_CLI_USERS,
	GET_CLI_USERS_SUCCESS,
	GET_CLI_USERS_FAIL,
	GET_GROUP_CONFIGURATION,
	GET_GROUP_CONFIGURATION_SUCCESS,
	GET_GROUP_CONFIGURATION_FAIL,
	GET_AP_NAME,
	GET_AP_NAME_SUCCESS,
	GET_AP_NAME_FAIL,
	GET_INTERFACE_LIST,
	GET_INTERFACE_LIST_SUCCESS,
	GET_INTERFACE_LIST_FAIL,
	UPDATE_TIP_CONFIG,
	UPDATE_TIP_CONFIG_SUCCESS,
	UPDATE_TIP_CONFIG_ERROR,
	ADD_ACCESSCLI_MODAL,
	GET_TIP_CONFIG,
	GET_TIP_CONFIG_SUCCESS,
	GET_TIP_CONFIG_FAIL,
	GET_GROUP_INFO,
	GET_GROUP_INFO_SUCCESS,
	GET_GROUP_INFO_FAIL,
	GET_ROGUE_AP_LIST,
	GET_ROGUE_AP_LIST_SUCCESS,
	GET_ROGUE_AP_LIST_FAIL,
	GET_TIP_AP_CONFIG,
	GET_TIP_AP_CONFIG_SUCCESS,
	GET_TIP_AP_CONFIG_FAIL,
	DELETE_KNOWN_ROGUE,
	MOVE_TO_KWOWN_ROGUE,
	BULK_UPLOAD_KNOWN,
	DELETE_KNOWN_ROGUE_SUCCESS,
	DELETE_KNOWN_ROGUE_FAIL,
	BULK_UPLOAD_KNOWN_SUCCESS,
	BULK_UPLOAD_KNOWN_FAIL,
	MOVE_TO_KWOWN_ROGUE_SUCCESS,
	MOVE_TO_KWOWN_ROGUE_FAIL,
	RESET_ROGUE_AP_ACTIONS,
	UPDATE_TIP_AP_CONFIG_FAIL,
	RESET_TIP_ACTIONS,
	UPDATE_TIP_AP_CONFIG_SUCCESS,
	ROGUE_WIFI_SCAN,
	ROGUE_WIFI_SCAN_SUCCESS,
	ROGUE_WIFI_SCAN_FAIL,
} from '../../constants/groupConfigurationConstants/groupConfigurationConstants';

/**
 * Reducer function for managing VLAN Pool list state.
 *
 * This reducer handles actions related to fetching vlan pool data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the vlan pool list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const cliClientReducer = (
	state = {
		clientClientList: {},
		configData: {},
		accessPointData: {},
		interfaceListData: {},
		tipData: {},
		tipInterfaceData: {},
		addAccessCliModal: false,
		groupInfo: { loading: false, data: {}, error: null },
		tipApConfig: {},
		tipStatus: null,
		tipError: null,
		apDetailsApiLoading: false
	},
	action
) => {
	switch (action.type) {
		case GET_CLI_USERS:
			return {
				...state,
				loading: true,
			};
		case GET_CLI_USERS_SUCCESS:
			return {
				...state,
				loading: false,
				clientClientList: action.payload,
			};
		case GET_CLI_USERS_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case GET_GROUP_CONFIGURATION:
			return {
				...state,
				loading: true,
			};
		case GET_GROUP_CONFIGURATION_SUCCESS:
			return {
				...state,
				loading: false,
				configData: action.payload,
			};
		case GET_GROUP_CONFIGURATION_FAIL:
			return {
				...state,
				loading: false,
				apDetailsApiLoading : false,
				error: action.payload,
			};
		case GET_AP_NAME:
			return {
				...state,
				loading: true,
				accessPointData: {},
				apDetailsApiLoading : true
			};
		case GET_AP_NAME_SUCCESS:
			return {
				...state,
				loading: false,
				accessPointData: action.payload,
				apDetailsApiLoading : false
			};
		case GET_AP_NAME_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
				apDetailsApiLoading : false
			};
		case GET_TIP_AP_CONFIG:
			return {
				...state,
				tipApConfig: {},
			};
		case GET_TIP_AP_CONFIG_SUCCESS:
			return {
				...state,
				tipApConfig: action.payload,
			};
		case GET_TIP_AP_CONFIG_FAIL:
			return {
				...state,
				tipApConfig: {},
			};
		case UPDATE_TIP_CONFIG:
			return {
				...state,
				loading: true,
				tipData: {},
				tipStatus: UI_STATES.LOADING,
				tipError: null,
			};
		case UPDATE_TIP_CONFIG_SUCCESS:
			return {
				...state,
				loading: false,
				tipData: action.payload,
			};
		case UPDATE_TIP_AP_CONFIG_SUCCESS: 
			return {
				...state,
				loading: false,
				tipData: action.payload,
				tipStatus: UI_STATES.SUCCESS,
				tipError: null,
			}
		case UPDATE_TIP_AP_CONFIG_FAIL:
			return {
				...state,
				loading: false,
				tipStatus: UI_STATES.FAILURE,
				tipError: action.payload,
			}
		case RESET_TIP_ACTIONS:
			return {
				...state,
				loading: false,
				tipStatus: null,
				tipError: null,
				tipData: [],
			}
		case UPDATE_TIP_CONFIG_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case GET_TIP_CONFIG:
			return {
				...state,
				loading: true,
				tipInterfaceData: {},
			};
		case GET_TIP_CONFIG_SUCCESS:
			return {
				...state,
				loading: false,
				tipInterfaceData: action.payload,
			};
		case GET_TIP_CONFIG_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case ADD_ACCESSCLI_MODAL:
			return {
				...state,
				addAccessCliModal: action.payload,
			};
		case GET_GROUP_INFO:
			return {
				...state,
				groupInfo: { ...state.groupInfo, loading: true },
			};
		case GET_GROUP_INFO_SUCCESS:
			return {
				...state,

				groupInfo: {
					...state.groupInfo,
					loading: false,
					data: action.payload,
				},
			};
		case GET_GROUP_INFO_FAIL:
			return {
				...state,
				groupInfo: {
					...state.groupInfo,
					loading: false,
					error: action.payload,
				},
			};
		default:
			return state;
	}
};
export const interfaceListReducer = (
	state = { interfaceListData: {} },
	action
) => {
	switch (action.type) {
		case GET_INTERFACE_LIST:
			return {
				loading: true,
			};
		case GET_INTERFACE_LIST_SUCCESS:
			return {
				loading: false,
				interfaceListData: action.payload,
			};
		case GET_INTERFACE_LIST_FAIL:
			return {
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

export const rogueApListReducer = (
	state = {
		loading: false,
		rogueApList: {},
		error: null,
	},
	action
) => {
	switch (action.type) {
		case GET_ROGUE_AP_LIST:
			return {
				...state,
				loading: true,
			};
		case GET_ROGUE_AP_LIST_SUCCESS:
			return {
				...state,
				loading: false,
				rogueApList: action.payload,
			};
		case GET_ROGUE_AP_LIST_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

export const rogueApActionReducer = (
	state = {
		loading: false,
		deleteSuccess: null,
		deleteError: null,
		trustSuccess: null,
		trustError: null,
		bulkUploadSuccess: null,
		bulkUploadError: null,
		wifiScanSuccess: null,
		wifiScanError: null,
	},
	action
) => {
	switch (action.type) {
		case DELETE_KNOWN_ROGUE:
			return {
				...state,
				loading: true,
				deleteSuccess: null,
				deleteError: null,
				trustSuccess: null,
				trustError: null,
				bulkUploadSuccess: null,
				bulkUploadError: null,
				wifiScanSuccess: null,
				wifiScanError: null,
			};
		case MOVE_TO_KWOWN_ROGUE:
			return {
				...state,
				loading: true,
				deleteSuccess: null,
				deleteError: null,
				trustSuccess: null,
				trustError: null,
				bulkUploadSuccess: null,
				bulkUploadError: null,
				wifiScanSuccess: null,
				wifiScanError: null,
			};
		case BULK_UPLOAD_KNOWN:
			return {
				...state,
				loading: true,
				deleteSuccess: null,
				deleteError: null,
				trustSuccess: null,
				trustError: null,
				bulkUploadSuccess: null,
				bulkUploadError: null,
				wifiScanSuccess: null,
				wifiScanError: null,
			};
		case ROGUE_WIFI_SCAN:
			return {
				...state,
				loading: true,
				deleteSuccess: null,
				deleteError: null,
				trustSuccess: null,
				trustError: null,
				bulkUploadSuccess: null,
				bulkUploadError: null,
				wifiScanSuccess: null,
				wifiScanError: null,
			};
		case DELETE_KNOWN_ROGUE_SUCCESS:
			return {
				...state,
				loading: false,
				deleteSuccess: action.payload,
				deleteError: null,
			};
		case DELETE_KNOWN_ROGUE_FAIL:
			return {
				...state,
				loading: false,
				deleteSuccess: null,
				deleteError: action.payload,
			};
		case BULK_UPLOAD_KNOWN_SUCCESS:
			return {
				...state,
				loading: false,
				bulkUploadSuccess: action.payload,
				bulkUploadError: null,
			};
		case BULK_UPLOAD_KNOWN_FAIL:
			return {
				...state,
				loading: false,
				bulkUploadSuccess: null,
				bulkUploadError: action.payload,
			};
		case MOVE_TO_KWOWN_ROGUE_SUCCESS:
			return {
				...state,
				loading: false,

				trustSuccess: action.payload,
				trustError: null,
			};
		case MOVE_TO_KWOWN_ROGUE_FAIL:
			return {
				...state,
				loading: false,

				trustSuccess: null,
				trustError: action.payload,
			};
		case ROGUE_WIFI_SCAN_SUCCESS:
			return {
				...state,
				loading: false,
				wifiScanSuccess: action.payload,
				wifiScanError: null,
			};
		case ROGUE_WIFI_SCAN_FAIL:
			return {
				...state,
				loading: false,
				wifiScanSuccess: null,
				wifiScanError: action.payload,
			};
		case RESET_ROGUE_AP_ACTIONS:
			return {
				...state,
				loading: false,
				deleteSuccess: null,
				deleteError: null,
				trustSuccess: null,
				trustError: null,
				bulkUploadSuccess: null,
				bulkUploadError: null,
				wifiScanSuccess: null,
				wifiScanError: null,
			};

		default:
			return state;
	}
};
